// extracted by mini-css-extract-plugin
var _1 = "ZdAiV";
var _2 = "uaJSv";
var _3 = "r86p4";
export { _1 as "copiable", _2 as "type", _3 as "value" }
